/**
 * Pan gesture math (v0.9 RFC §3) — PURE and Phaser-free so the headless test
 * suite exercises it directly. `pan.ts` binds these to a scene's camera.
 */

export const PAN = {
  /** A gesture is a TAP (not a drag) below this travel... */
  tapMaxTravelPx: 12,
  /** ...and below this duration. */
  tapMaxMs: 350,
  /** Fling velocity decay per 16ms step (0..1). */
  flingDecay: 0.94,
  /** Fling stops below this speed (px per step). */
  flingMinSpeed: 0.4,
} as const;

/** Clamp a camera scrollY so the view never leaves [0, worldH]. */
export function clampScroll(scrollY: number, worldH: number, viewH: number): number {
  const max = Math.max(0, worldH - viewH);
  return Math.max(0, Math.min(max, scrollY));
}

/** Tap-vs-drag: short AND small = tap; anything else is a pan gesture. */
export function isTap(travelPx: number, elapsedMs: number): boolean {
  return travelPx < PAN.tapMaxTravelPx && elapsedMs < PAN.tapMaxMs;
}

/** One fling step: decayed velocity (0 when it drops below the floor). */
export function flingStep(vel: number): number {
  const v = vel * PAN.flingDecay;
  return Math.abs(v) < PAN.flingMinSpeed ? 0 : v;
}
